export default "__VITE_ASSET__BnjG7urT__"